<div class="container-fluid px-5 py-5 d-flex justify-content-center image_background_style" style="height: 100vh;">
    <div class="row w-100">
        <!-- Sidebar -->
        <div class="col-12 d-flex overflow-x-hidden px-0">
            <aside [ngClass]="{'col-sm-3 col-md-2 col-lg-1 col-xl-1 px-2 align-items-center': !isSidebarExpanded, 'col-sm-4 col-md-3 col-lg-2 col-xl-2 align-items-stretch px-4': isSidebarExpanded}"
                class="text-white d-flex flex-column justify-content-between ">
                <div class="d-flex flex-column align-content-center align-items-center">
                  <!-- Logo -->
                  <div class="logo m-4 text-center position-relative">
                      <img src="{{  isSidebarExpanded ? '../../assets/icons/LogoBig.svg' : '../../assets/icons/LogoSmall.svg' }}" alt="Logo" class="img-fluid"
                          (click)="toggleSidebar()" style="cursor: pointer; width: 100%" [ngClass]="loadingAjax ? 'opacity-50' : ''">
                    <div class="position-absolute top-0 left-0 w-100 h-100 align-items-center justify-content-center {{loadingAjax ? 'd-flex' : 'd-none'}}" id="ajaxSpinner">
                      <div class="spinner-border" role="status">
                      </div>
                    </div>
                  </div>

                  <!-- Links or Sidebar content -->
                  <button class="btn btn_aside_style mb-4 d-flex align-items-center {{ isSidebarExpanded ? 'w-100' : 'w-50' }}"
                      [ngClass]="{'btn_aside_style': !rlahome.isActive, 'btn_aside_active_style': rlahome.isActive,
                          'justify-content-center': !isSidebarExpanded,'justify-content-start px-4': isSidebarExpanded}"
                      [routerLink]="['/dashboard/home']"
                      [routerLinkActive]="'btn_aside_active_style'"
                      #rlahome="routerLinkActive">
                      <i class="bi bi-house-door fs-2"></i>
                      <label *ngIf="isSidebarExpanded" class="fs-5 ms-3">Home</label>
                  </button>
                  <button class="btn btn_aside_style mb-4 {{ isSidebarExpanded ? 'w-100' : 'w-50' }} d-flex align-items-center"
                      [ngClass]="{'btn_aside_style': !rlamonitoring.isActive, 'btn_aside_active_style': rlamonitoring.isActive,
                          'justify-content-center': !isSidebarExpanded,'justify-content-start px-4': isSidebarExpanded}"
                      [routerLink]="['/dashboard/monitoring']"
                      [routerLinkActive]="'btn_aside_active_style'"
                      #rlamonitoring="routerLinkActive">
                      <i class="bi bi-display fs-2"></i>
                      <label *ngIf="isSidebarExpanded" class="fs-5 ms-3">Monitoring</label>
                  </button>
                  @if(isAdmin){
                  <button class="btn btn_aside_style mb-4 {{ isSidebarExpanded ? 'w-100' : 'w-50' }} d-flex align-items-center"
                          [ngClass]="{'btn_aside_style': !rlahistory.isActive, 'btn_aside_active_style': rlahistory.isActive,
                          'justify-content-center': !isSidebarExpanded,'justify-content-start px-4': isSidebarExpanded}"
                          [routerLink]="['/dashboard/history']"
                          [routerLinkActive]="'btn_aside_active_style'"
                          #rlahistory="routerLinkActive">
                    <i class="bi bi-clipboard-pulse fs-2"></i>
                    <label *ngIf="isSidebarExpanded" class="fs-5 ms-3">Time Tracking</label>
                  </button>
                  }
                  <button class="btn btn_aside_style mb-4 {{ isSidebarExpanded ? 'w-100' : 'w-50' }} d-flex align-items-center"
                      [ngClass]="{'btn_aside_style': !rlaadministration.isActive, 'btn_aside_active_style': rlaadministration.isActive,
                          'justify-content-center': !isSidebarExpanded,'justify-content-start px-4': isSidebarExpanded}"[routerLink]="['/dashboard/administration']"
                      [routerLinkActive]="'btn_aside_active_style'"
                      #rlaadministration="routerLinkActive">
                      <i class="bi bi-people fs-2"></i>
                      <label *ngIf="isSidebarExpanded" class="fs-5 ms-3">Administration</label>
                  </button>
                  </div>
              <div class="mb-4">
                <div class="d-flex mb-2 justify-content-center">
                  <div class="position-relative d-flex bg-white text-info me-3 align-content-center justify-content-center"
                       style="border-radius: 50%;font-size: 1.5rem; width: 3rem; height: 3rem;line-height: 2.9rem;">
                    <div class="align-middle">
                      {{user?.firstname?.charAt(0) ?? " "}}{{user?.lastname?.charAt(0) ?? " "}}
                    </div>
                  </div>
                  <div class="{{ isSidebarExpanded ? '' : 'd-none'}} me-2 d-flex flex-column justify-content-center">
                    <h6 class="mb-0">{{user?.firstname ?? " "}} {{user?.lastname ?? " "}}</h6>
                    <small>{{user?.email}}</small>
                  </div>
                  <button class="bg-transparent border-0" style="font-size: 2rem;line-height: 3rem;" (click)="logout()"><i class="bi bi-box-arrow-right" style="font-size: 2rem;line-height: 2rem;"></i></button>
                </div>
              </div>

            </aside>

            <div class="content_area d-flex flex-column ps-5"
            [ngClass]="{'col-lg-11 col-md-10 col-sm-9': !isSidebarExpanded, 'col-lg-10 col-md-9 col-sm-8': isSidebarExpanded}">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</div>
